import React from 'react'

import ModalAddRelation from "./modal-add-relation"
import {MentionOption} from "../../gd-components/editor/plugins/mentions/option"
import {EntitySelectorEntityType} from "../../gd-components/entity-selector/@const"

// Opens the entity selector for LINKING a related item (a MANUAL_LINK), for any
// owner -- task, meeting, document, project, page.
//
// The picked entity goes to `onSelected`, which creates the link from the
// current item (see `model2/relation/actions/create-related-item.tsx`).
//
// `initialEntityType` only picks the tab to LAND on -- the add menu
// (`related-items/common/add-menu.tsx`) passes what the user chose there. The
// tabs stay switchable, so a wrong guess costs one click, not a reopen.
//
// `projectId` is the owner's OWN project (if any) -- passed through so the
// Task/Project tabs open with it (and its parents) already expanded, same as
// `EntitySelector` does for the mention popover.
export default function addRelationModal(onSelected: {(entity: MentionOption): void},
                                         initialEntityType?: EntitySelectorEntityType,
                                         projectId?: ID) {
    gd.modal.showV5(
        <ModalAddRelation
            onSelected          = {onSelected}
            initialEntityType   = {initialEntityType}
            projectId           = {projectId}
        />,
        {
            name: 'add-relation'
        }
    )
}
